import Vue from 'vue'

// 引入了所有的组件，你可以选择性删减
import {
  /* eslint-disable no-unused-vars */
  Style,
  Checkbox,
  Button,
  Loading,
  Form,
  Dialog,
  Toast
} from 'cube-ui'

Vue.use(Button)
Vue.use(Checkbox)
Vue.use(Loading)
Vue.use(Form)
Vue.use(Dialog)
Vue.use(Toast)
